import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';
import { CdDevelopmentScenarioSharedHelper } from 'src/cdScripts/Helpers/Cards/CdDevelopmentScenarioSharedHelper';
import { Guid } from 'tessa/platform';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';

export class CdDevelopmentScenarioTaskUIExtension extends CardUIExtension {
  public async saving(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkDevelopmentScenarionTypeID)) {
      return;
    }
    let tasks = context.card.tasks;

    await CdGeneralDocumentationClientHelper.CheckFieldsAfterTaskComplete(context, tasks
      ,CdDevelopmentScenarioSharedHelper.ApproverTaskStoreInfo.TaskStartProcessTypesList
      ,CdDevelopmentScenarioSharedHelper.ApproverTaskStoreInfo.TaskStartProcessOptionsList
      ,CdDevelopmentScenarioSharedHelper.CheckFileCategoryList      
      ,CdDevelopmentScenarioSharedHelper.ExcludeRolesFromCheckList);
  } 
}